export default "__VITE_ASSET__CnIhGZic__"